import {
  notifyMeSeasonSummerEndDate,
  notifyMeSeasonSummerStartDate,
} from '@velasca/constants'
import { isDateDayMonthInRange } from './isDateDayMonthInRange'

/**
 * It should return a boolean representing if current date is inside the notifyMe summer range period.
 *
 */
export const isSummerNotifyMe = (): boolean => {
  return isDateDayMonthInRange({
    currentDate: new Date(),
    startDate: notifyMeSeasonSummerStartDate,
    endDate: notifyMeSeasonSummerEndDate,
  })
}
